"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useContactInfoBoxModal = void 0;
const translations_1 = __importDefault(require("./translations"));
const trackingActions = __importStar(require("./trackingActions"));
const useContactInfoBoxModal = ({ pageName, tracker, translate }) => {
    return {
        onClickButton: () => {
            tracker?.track(trackingActions.CONTACT_INFO_MODAL_TD_BUTTON_PRIMARY, {
                pageName,
            });
        },
        onCloseModal: () => {
            tracker?.track(trackingActions.CONTACT_INFO_MODAL_TD_LINK_CLOSE, {
                pageName,
            });
        },
        onLoad: () => {
            tracker?.track(trackingActions.CONTACT_INFO_MODAL_TD, {
                pageName,
            });
        },
        title: translate(translations_1.default.CONTACT_INFO_MODALTD.TITLE),
        description: translate(translations_1.default.CONTACT_INFO_MODALTD.DESCRIPTION),
        buttonText: translate(translations_1.default.CONTACT_INFO_MODALTD.BUTTON_TEXT),
    };
};
exports.useContactInfoBoxModal = useContactInfoBoxModal;
//# sourceMappingURL=useContactInfoBoxModal.js.map